// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3G_3b";
var _4 = "clickable-2KqaH";
var _5 = "overlay-17xgQ";
var _6 = "inner-rTxKR";
var _7 = "city-2Y0Np";
var _8 = "main_city-1AiJy";
var _9 = "cities_chain-nqI2L";
var _a = "period-BrTkk";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "clickable", _5 as "overlay", _6 as "inner", _7 as "city", _8 as "main_city", _9 as "cities_chain", _a as "period" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "clickable": _4, "overlay": _5, "inner": _6, "city": _7, "main_city": _8, "cities_chain": _9, "period": _a }
